import { Bar, BarChart, Cell, CartesianGrid, ReferenceLine, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { NET_NEW_REVENUE } from "./exampleData";
import {
  BORDER,
  CHART_NEGATIVE,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Net New Revenue by month — the net change in MRR after every movement. Each bar
 * is colored by sign: a gain in green, a loss in red, with a zero line so down
 * months read at a glance.
 */
const NetNewRevenueChart = () => (
  <MetricChartFrame
    caption="Net new revenue is positive most months but dips below zero in February — the honest measure of momentum, since a down month means churn and contraction outran new and expansion."
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={NET_NEW_REVENUE} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "Net new revenue"]}
      />
      <ReferenceLine y={0} stroke={MUTED_FG} />
      <Bar dataKey="value" radius={[4, 4, 0, 0]} isAnimationActive={false}>
        {NET_NEW_REVENUE.map((row) => (
          <Cell key={row.label} fill={row.value >= 0 ? CHART_POSITIVE : CHART_NEGATIVE} />
        ))}
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default NetNewRevenueChart;
